



































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { uuid } from '@/util/uuid';
@Component({
  components: {},
})
export default class WorkTicketElectroEquipList extends Vue {
  @Prop(Number) unitId: any;
  private dataText: any = '123123';
  private drawer = false;

  @Prop() private formProp: any;

  private form: any = {};

  mounted() {
    if (JSON.stringify(this.formProp) == '{}') {
      this.form = {
        id: uuid(),
        label: '用电设备清单',
        placeholder: '',
        required: true,
        // option: '1',
        // scan: false,
      };
      this.$nextTick(() => {
        this.$emit('unit_set_data', { id: this.unitId, form: this.form });
      });
    } else {
      this.form = this.formProp;
    }
    // console.log(this.form);
  }

  closeTap() {
    // console.log(this.unitId);
    this.$emit('i_close', { id: this.unitId });
  }

  beforeClose(done: any) {
    this.$emit('unit_set_data', { id: this.unitId, form: this.form });
    done();
  }
}
